import styled, { css } from 'styled-components';

import { device } from 'styles/breakpoints';

export const GoogleAutocompleteWrapper = styled.div<{ hasLabel: boolean }>`
  width: 100%;
  max-width: 840px;
  background-color: ${({ theme }) => theme.colors.white};
  height: auto;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;

  ${({ hasLabel }) =>
    hasLabel &&
    css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .outlined-input-label {
        margin: 0;
      }

      .places-container {
        width: 100%;
      }
    `}

  .places {
    &-container {
      flex-grow: 1;
      display: flex;
      align-items: center;
      gap: 24px;

      .autocomplete {
        flex-grow: 1;
        height: 100%;

        &-input {
          font-weight: ${({ theme }) => theme.typography.fontWeights.light};
          width: 100%;
          max-width: 840px;
          background-color: ${({ theme }) => theme.colors.white};
          margin: 0.5rem 0;
          padding: 0.5rem 0.625rem 0.5625rem;
          height: 43px;
          font-size: 16px;
          border: 1px solid ${({ theme }) => theme.colors.grayPallet22};

          &:hover {
            border-color: hsl(0, 0%, 70%);
          }

          &:focus {
            border: 1px solid ${({ theme }) => theme.colors.bluePallet2};
          }

          &.invalid {
            border: 1px solid ${({ theme }) => theme.colors.red};
          }

          &::placeholder {
            color: ${({ theme }) => theme.colors.grayPallet13};
          }

          @media ${device.tablet} {
            font-size: 12px;
            line-height: 24px;
          }
        }

        &-dropdown {
          box-shadow: 0 5px 20px 0 rgb(0 0 0 / 9%);
          padding-left: 8px;
          padding-right: 8px;
          position: absolute;
          z-index: 999;
          top: calc(100% - 1px);
          width: 100%;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
          background-color: ${({ theme }) => theme.colors.white};
          font-weight: ${({ theme }) => theme.typography.fontWeights.light};

          > div {
            padding: 8px 0;
            margin-bottom: 8px;
            cursor: pointer;

            &:hover {
              background-color: ${({ theme }) => theme.colors.grayPallet1}1A;
            }
          }
        }

        &-text-field-error {
          font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
          font-size: 12px;
          line-height: 20px;
          color: ${({ theme }) => theme.colors.red};
        }
      }

      > button {
        width: 182px;
        height: 64px;
        padding: 20px 30px;
        border-radius: 60px;

        > p {
          color: ${({ theme }) => theme.colors.bluePallet1};
        }

        @media ${device.tablet} {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          padding: 16px;

          > p {
            display: none;
          }
        }
      }
    }
  }

  &.variant-1 {
    height: 110px;
    border-radius: 40px;

    @media ${device.laptop} {
      height: 60px;
      padding: 2px;
      padding-left: 30px;
      border-radius: 60px;
    }

    .places-container {
      > button {
        background-color: ${({ theme }) => theme.colors.bluePallet1};
        height: 94px;
        border-radius: 32px;

        > p {
          color: ${({ theme }) => theme.colors.white};
        }

        @media ${device.laptop} {
          height: 56px;
        }
      }
    }

    .places-note {
      width: max-content;
      left: 50%;
      transform: translateX(-50%);
      background-color: ${({ theme }) => theme.colors.greenPallet2};
      padding: 12px 28px;

      @media ${device.mobile} {
        width: 207px;
        padding: 8px 16px;
      }
    }
  }
`;
